import React, { useState } from "react";
import { BaseButtons } from "../../../../../common-components";
import { colors } from "../../../../../../themes/Colors";
import { AgencySelectPopUp } from "./components";

const AgencyOptionsDisplay = () => {
  const [addAgencyPop, setAddAgencyPop] = useState(false);
  const [optionTitle, setoptionTitle] = useState("loading");
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ minHeight: 10 }}></div>
      <div style={{ width: "90%", fontSize: 14 }}>
        Select a Agency by clicking on a service and assign a agency that will
        allow you to access the Agency which can perfomr task for you and your
        vehicle as requested in our actions menu on the vehicle screen
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <div style={{ width: "90%", marginBottom: 10, fontWeight: "bold" }}>
          FINES
        </div>
        <BaseButtons
          label={"ADD AGENCY"}
          width={"90%"}
          backgroundColor={colors.greenDark}
          borderRadius={8}
          onClick={() => {
            setAddAgencyPop(true);
            setoptionTitle("FINES");
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <div style={{ width: "90%", marginBottom: 10, fontWeight: "bold" }}>
          LISENSING
        </div>
        <BaseButtons
          label={"ADD AGENCY"}
          width={"90%"}
          backgroundColor={colors.greenDark}
          borderRadius={8}
          onClick={() => {
            setAddAgencyPop(true);
            setoptionTitle("LISENSING");
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <div style={{ width: "90%", marginBottom: 10, fontWeight: "bold" }}>
          VALUATION
        </div>
        <BaseButtons
          label={"ADD AGENCY"}
          width={"90%"}
          backgroundColor={colors.greenDark}
          borderRadius={8}
          onClick={() => {
            setAddAgencyPop(true);
            setoptionTitle("VALUATION");
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <div style={{ width: "90%", marginBottom: 10, fontWeight: "bold" }}>
          SALES
        </div>
        <BaseButtons
          label={"ADD AGENCY"}
          width={"90%"}
          backgroundColor={colors.greenDark}
          borderRadius={8}
          onClick={() => {
            setAddAgencyPop(true);
            setoptionTitle("SALES");
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <div style={{ width: "90%", marginBottom: 10, fontWeight: "bold" }}>
          SPARES
        </div>
        <BaseButtons
          label={"ADD AGENCY"}
          width={"90%"}
          backgroundColor={colors.greenDark}
          borderRadius={8}
          onClick={() => {
            setAddAgencyPop(true);
            setoptionTitle("SPARES");
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <div style={{ width: "90%", marginBottom: 10, fontWeight: "bold" }}>
          SERVICES
        </div>
        <BaseButtons
          label={"ADD AGENCY"}
          width={"90%"}
          backgroundColor={colors.greenDark}
          borderRadius={8}
          onClick={() => {
            setAddAgencyPop(true);
            setoptionTitle("SERVICES");
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <div style={{ width: "90%", marginBottom: 10, fontWeight: "bold" }}>
          AUTO-MOTIVE FITMENT
        </div>
        <BaseButtons
          label={"ADD AGENCY"}
          width={"90%"}
          backgroundColor={colors.greenDark}
          borderRadius={8}
          onClick={() => {
            setAddAgencyPop(true);
            setoptionTitle("AUTO-MOTIVE FITMENT");
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <div style={{ width: "90%", marginBottom: 10, fontWeight: "bold" }}>
          TOWING
        </div>
        <BaseButtons
          label={"ADD AGENCY"}
          width={"90%"}
          backgroundColor={colors.greenDark}
          borderRadius={8}
          onClick={() => {
            setAddAgencyPop(true);
            setoptionTitle("TOWING");
          }}
        />
        <div style={{ minHeight: 20 }}></div>
      </div>
      <AgencySelectPopUp
        display={addAgencyPop}
        title={optionTitle}
        setAddAgencyPop={setAddAgencyPop}
      />
    </div>
  );
};

export default AgencyOptionsDisplay;
